/**
 * invoiceDefaults.js — Due date + terms defaults for new invoices
 *
 * Deposits are always due on receipt. Final (balance/full) invoices are due
 * today + settings.finalTermsDays (default 0 = due on receipt), so grace days
 * can be added in Settings without code changes.
 */

import { toLocalDateStr } from './utils';

// Accepts either the full settings row ({ data: {...} }) or unwrapped
// settings.data (the JobPipeline/QuickInvoiceModal pattern).
export function finalTermsDays(settings) {
  const data = settings?.data ?? settings;
  const days = Number(data?.finalTermsDays);
  return Number.isFinite(days) ? days : 0;
}

export function dueDateInDays(days) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return toLocalDateStr(d);
}

export function defaultDueDate(invoiceType, settings) {
  return dueDateInDays(invoiceType === 'deposit' ? 0 : finalTermsDays(settings));
}

// Days from a stored terms string ("Net 30" → 30, "Due on receipt" → 0),
// or null when unparseable — lets per-invoice terms override the default.
export function parseTermsDays(terms) {
  if (!terms) return null;
  if (/receipt/i.test(terms)) return 0;
  const m = String(terms).match(/\d+/);
  return m ? Number(m[0]) : null;
}

export function termsLabel(invoiceType, settings) {
  const days = invoiceType === 'deposit' ? 0 : finalTermsDays(settings);
  return days === 0 ? 'Due on receipt' : `Net ${days}`;
}
